import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-spin-buttons" }
const _hoisted_2 = { class: "bonusomat-spin-button__tooltip" }

import { computed } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { SpinAutomatState } from "../../../models/bonusomat-spin-types";
import { bonImgUrl } from "../../../utils/image-src";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-spin-buttons',
  props: {
    state: {},
    allwynPageUrl: {}
  },
  emits: ["spinClick", "closeModal"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const isPrimaryButtonDisabled = computed(() => props.state != "ACTIVE");
const showCloseButton = computed(() => props.state == "EMPTY" || props.state == "WINNING");
const showTooltip = computed(() => props.state == "DISABLED");
const caretSrc = computed(() => bonImgUrl("tooltip-caret", "svg"));
const closeBtnIcon = computed(() => (props.allwynPageUrl ? "arrow-right" : "cross"));
const closeBtnText = computed(() => (props.allwynPageUrl ? "Více o zážitku" : "Zavřít Bonusomat"));

const spinClickInternal = () => emit("spinClick");
const closeClickInternal = () => !props.allwynPageUrl && emit("closeModal");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(DsButton, {
      class: "bonusomat-spin-button__spin",
      onClick: spinClickInternal,
      size: "lg",
      "is-disabled": isPrimaryButtonDisabled.value,
      "icon-right": "b-mat",
      "is-block": ""
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(" Zatočit bonusomatem ")
      ])),
      _: 1,
      __: [0]
    }, 8, ["is-disabled"]), [
      [_vShow, !showCloseButton.value]
    ]),
    _withDirectives(_createVNode(DsButton, {
      class: _normalizeClass(["bonusomat-spin-button__close", { 'bonusomat-spin-button__close--allwyn': _ctx.allwynPageUrl }]),
      onClick: closeClickInternal,
      href: _ctx.allwynPageUrl,
      eventName: _ctx.allwynPageUrl ? 'openLinkBrowser' : null,
      "event-argument": _ctx.allwynPageUrl ? _ctx.allwynPageUrl : null,
      size: "lg",
      type: "interaction",
      theme: "dark",
      "icon-right": closeBtnIcon.value,
      "open-in-new-tab": true,
      "is-block": ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(closeBtnText.value), 1)
      ]),
      _: 1
    }, 8, ["class", "href", "eventName", "event-argument", "icon-right"]), [
      [_vShow, showCloseButton.value]
    ]),
    _createVNode(TransitionFade, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(WebpImage, {
            class: "bonusomat-spin-button__tooltip-caret",
            src: caretSrc.value,
            alt: "",
            width: 24,
            height: 8
          }, null, 8, ["src"]),
          _cache[1] || (_cache[1] = _createTextVNode(" Zatočit Bonusomatem si můžete vždy pouze 1 x denně. "))
        ], 512), [
          [_vShow, showTooltip.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})